import autosize from 'autosize';
import block from 'propmods';
// eslint-disable-next-line @typescript-eslint/no-use-before-define
import React, { useEffect, useRef } from 'react';

import CircularProgressbar from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import { TextArea as LegoTextArea } from 'lego-on-react';

import './TextArea.scss';

interface Props {
    text: string;
    limit?: number;
    rows: number;
    onChange: (_value: string) => void;
    disabled?: boolean;
    name?: string;
    autosized?: boolean;
    placeholder?: string;
    rtl?: boolean;
}

const b = block('PASKILLSTextArea');

const TextArea: React.FC<Props> = (props) => {
    const { limit, text, rows, disabled, onChange, name, autosized = true, placeholder, rtl } = props;

    const remainder = (limit ?? 0) - text.length;
    const percentage = (1 - remainder / (limit ?? 0)) * 100;
    const danger = remainder < 0;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const textareaRef = useRef<any>(null);

    useEffect(() => {
        const node = textareaRef.current;
        if (autosized && node) {
            autosize(node._current);

            return () => {
                if (node) {
                    autosize.destroy(node._control);
                }
            };
        }
    }, []);

    return (
        <div {...b()}>
            <LegoTextArea
                name={name}
                theme="normal"
                size="s"
                rows={rows}
                text={text}
                onChange={onChange}
                disabled={disabled}
                ref={textareaRef}
                placeholder={placeholder}
            />
            {limit && (
                <div {...b('counter', { danger, rtl })}>
                    <span {...b('remainder')}>{remainder}</span>

                    <CircularProgressbar
                        {...b('progress')}
                        percentage={percentage}
                        strokeWidth={50}
                        styles={{
                            path: {
                                strokeLinecap: 'butt',
                                // eslint-disable-next-line no-nested-ternary
                                stroke: danger ? '#c12a2a' : disabled ? '#aaaaaa' : '#ffdb4d',
                                transitionDuration: '0s',
                            },
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default TextArea;
